import { NuxtAxiosInstance } from '@nuxtjs/axios';
import { mapToChat } from './mapper';
import type { FetchChatsParams, Chat } from './type';

export const fetchChats = async (
  $axios: NuxtAxiosInstance,
  params: FetchChatsParams = {}
): Promise<Chat[]> => {
  const { data } = await $axios.get('/v1/career/chat', {
    params
  });
  return data.map(mapToChat);
};

export const fetchChat = async (
  $axios: NuxtAxiosInstance,
  chatId: number
): Promise<Chat> => {
  const { data } = await $axios.get(`/v1/career/chat/${chatId}`);
  return mapToChat(data);
};

export const readMessages = async (
  $axios: NuxtAxiosInstance,
  chatId: number
): Promise<Chat> => {
  const { data } = await $axios.post(`/v1/career/chat/${chatId}/read_messages`);
  return mapToChat(data);
};
